var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "youtube-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.585,
    height: 25.633,
    viewBox: "0 0 30.585 25.633",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".youtube-icon .a{fill:#e87722;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M605.155,84.877c-6.2-.092-11.688-1.354-24.637-.085-1.412.138-3.115,1.21-3.037,2.754.387,7.64-.526,11.817-.263,18.558a2.9,2.9,0,0,0,2.561,2.9c16.378,1.955,20.161.01,25.074-.461,1.389-.133,2.415-.749,2.554-2.263.794-8.66-.068-12,.263-18.46A2.7,2.7,0,0,0,605.155,84.877Zm-17.8,18.647-.744-13.589,14.135,7.111Z",
    transform: "translate(-577.17 -84.23)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYoutube);
export default __webpack_public_path__ + "static/media/ic_youtube.f98bbc07cf68c0ccbd69468cd88ed309.svg";
export { ForwardRef as ReactComponent };